
export const enum ResponseCode {
    SERVER_ERROR = -1,
    FAIL,
    OK,
    LOGIN,
    NOT_ALLOW,
}